import React, { useEffect } from "react";
import { Card, CardBody, CardTitle, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

const createInformesSectionPage = (titulo: string, descripcion: string) => {
  const SectionPage = () => {
    useEffect(() => {
      document.title = `${titulo} | Informes | Saas`;
    }, []);

    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={titulo} pageTitle="Informes" />

          <Card>
            <CardBody>
              <CardTitle tag="h4" className="mb-3">
                {titulo}
              </CardTitle>
              <p className="text-muted mb-0">{descripcion}</p>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  };

  return SectionPage;
};

export default createInformesSectionPage;
